import { Divider } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { IMPORT_STANDARD_DEVICES_CSV_ERROR_CODES_PARAMETERS, ORANGE } from '../../_config/consts';

export default class StandardDeviceAddCSVMessage extends React.Component {
  render() {
    const { devicesWithErrors } = this.props;
    
    return (
      <div style={{ marginTop: -10, marginBottom: 50 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <WarningIcon style={{ color: ORANGE, fontSize: 60 }} />
          <h3 style={{ color: '#3f3f3f', marginTop: 5, textAlign: 'center', fontWeight: 'bold' }}>{<Entity entity="importCSVEndWithWarning" />}</h3>
          <h4 style={{ color: '#3f3f3f', textAlign: 'center', margin: 0 }}>{<Entity entity="importDevicesCSVEndWithWarningDescription" />}</h4>
        </div>
        {devicesWithErrors && !_.isEmpty(devicesWithErrors) && (
          <div>
            <Divider style={{ marginTop: 20 }} />
            <h4 style={{ marginLeft: 10, color: '#3f3f3f', fontWeight: 'bold', textAlign: 'left' }}><Entity entity="warning" /></h4>
            {_.map(devicesWithErrors, (deviceError) => {
              const deviceId = deviceError.badgeUid || '';
              const userEmail = deviceError.userEmail || '';
              const errorCode = deviceError.errorCode || '';
              const errorCodeParameter = IMPORT_STANDARD_DEVICES_CSV_ERROR_CODES_PARAMETERS[errorCode] || '';
              const errorCodeParameterString = errorCodeParameter.string ? L20NContext.getSync(errorCodeParameter.string) : '';
              return (
                <h4 style={{ color: '#3f3f3f', textAlign: 'left', marginLeft: 20 }} key={deviceId}>{` • ${deviceId}${userEmail ? ` - ${userEmail}` : ''} ${errorCodeParameterString ? ` - ${errorCodeParameterString}` : ''}`}</h4>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
